module.exports = __webpack_public_path__ + "img/RFIB.d7bc1dae.png";